<script lang="ts" setup>
import { useRouter } from 'vue-router';
import technicalMessagesConstants from '@/constants/technicalMessagesConstants.ts';
import useUserStore from '@/stores/userStore.ts';
import useErrorsStore from '@/stores/errorStore.ts';

const filename = 'ManageRedirection.vue';
const userStore = useUserStore();
const router = useRouter();

await userStore.refreshUserInfos();

const targetPage = userStore.user.availablePages?.[0];

if (targetPage?.name) {
  router.push({ name: targetPage.name });
} else {
  useErrorsStore().addFatalError({
    name: technicalMessagesConstants.HTTP._401.TITLE,
    filename,
    message: technicalMessagesConstants.HTTP._401.MESSAGE,
  });
}
</script>
